/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
// tslint:disable comment-format

import * as React from 'react';

import AcclaimRatingsDisplay from './acclaim-ratings-display';

import { IAcclaimRatingsData } from './acclaim-ratings.data';
import { IAcclaimRatingsProps } from './acclaim-ratings.props.autogenerated';

//=======================================================================
/**
 * AcclaimRatings component
 * @extends {React.PureComponent<IAcclaimRatingsProps<IAcclaimRatingsData>>}
 */
//=======================================================================
class AcclaimRatings extends React.PureComponent<IAcclaimRatingsProps<IAcclaimRatingsData>> {

    //------------------------------------------------------
    //------------------------------------------------------
    constructor(props: IAcclaimRatingsProps<IAcclaimRatingsData>) {
        super(props);
    }

    //------------------------------------------------------
    //------------------------------------------------------
    public render(): JSX.Element {
        const { config } = this.props;

        const requestContext = this.props.context.actionContext.requestContext;
        const itemId = requestContext.urlTokens.itemId;
        const productID = parseInt(itemId || (requestContext.query && requestContext.query.productId) || '0', 10);

        const numberToShow = config.numberToShow ? +config.numberToShow : 0;

        return (
            <AcclaimRatingsDisplay productID={productID} numberToShow={numberToShow} showReviewer={config.showReviewer} showDate={config.showDate} noRatingText={config.noRatingText} />
        );
    }

}

export default AcclaimRatings;
